// eslint-disable-next-line
export function isNumberValue(arg) {
  return arg !== null && typeof arg === 'number';
}
// eslint-disable-next-line
export function isStringValue(arg) {
  return arg !== null && typeof arg === 'string';
}
